// extracted by mini-css-extract-plugin
export default {"aboutImg":"AboutLogo_aboutImg__L2P0k"};